import React from 'react';
import { Switch } from 'react-router-dom';
import ProtectedRoute from '../../utils/ProtectedRoute';
import OnBoardingFormTrackerPage from './OnBoardingFormTrackerPage';
import { usePermissions } from '../../providers/Permissions.provider';

// comment no issue
const Routes = (): React.JSX.Element => {
  const { permissions } = usePermissions();
  return (
    <Switch>
      <ProtectedRoute
        isAllowed={!!permissions.accountOnboardingFormAccess}
        showPermission
        exact
        path="/onboarding-form-tracker"
        component={OnBoardingFormTrackerPage}
      />
    </Switch>
  );
};

export default Routes;
